var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMycierczneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.8 55.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0085c3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ikony"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.65,43.09H.89c-.49,0-.89.4-.89.89s.4.89.89.89h1.75c.49,0,.89-.4.89-.89s-.39-.89-.89-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.13,43.09h-1.75c-.49,0-.89.4-.89.89s.4.89.89.89h1.75c.49,0,.89-.4.89-.89s-.4-.89-.89-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.52,39.46c-.49,0-.89.4-.89.89v1.75c0,.49.4.89.89.89s.89-.4.89-.89v-1.75c0-.49-.4-.89-.89-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.52,44.95c-.49,0-.89.4-.89.89v1.75c0,.49.4.89.89.89s.89-.4.89-.89v-1.75c0-.49-.4-.89-.89-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.42,50.33h-1.75c-.49,0-.89.4-.89.89s.4.89.89.89h1.75c.49,0,.89-.4.89-.89s-.4-.89-.89-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.91,50.33h-1.75c-.49,0-.89.4-.89.89s.4.89.89.89h1.75c.49,0,.89-.4.89-.89s-.4-.89-.89-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.29,46.7c-.49,0-.89.4-.89.89v1.75c0,.49.4.89.89.89s.89-.4.89-.89v-1.75c0-.49-.39-.89-.89-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.29,52.19c-.49,0-.89.4-.89.89v1.75c0,.49.4.89.89.89s.89-.4.89-.89v-1.75c0-.49-.39-.89-.89-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.84,8.17c.54-1.64,1.83-2.93,3.46-3.46-1.64-.54-2.93-1.83-3.46-3.46-.54,1.64-1.83,2.93-3.46,3.46,1.64.54,2.93,1.83,3.46,3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.07,9.02c.7-2.13,2.37-3.8,4.51-4.51-2.13-.7-3.81-2.37-4.51-4.51-.7,2.13-2.37,3.8-4.51,4.51,2.14.71,3.81,2.38,4.51,4.51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.65,24.77c-.5-.04-.98.11-1.35.45-.37.33-.57.81-.57,1.3v3.77c0,.49-.4.89-.89.89s-.89-.4-.89-.89v-8.95c0-.96-.69-1.77-1.57-1.86-.5-.04-.98.11-1.35.45-.37.33-.57.81-.57,1.3v9.06c0,.49-.4.89-.89.89s-.89-.4-.89-.89v-13.09c0-.96-.69-1.77-1.57-1.86-.5-.04-.98.11-1.35.45-.37.33-.57.81-.57,1.3v13.21c0,.49-.4.89-.89.89s-.89-.4-.89-.89v-9.06c0-.49-.21-.97-.57-1.3-.37-.34-.86-.49-1.35-.45-.89.08-1.57.9-1.57,1.86v18.9c0,.49-.4.89-.89.89s-.89-.4-.89-.89v-2.2l-2.35-3.82c-.53-.85-1.6-1.18-2.41-.74-.43.23-.73.62-.86,1.09-.13.47-.05.96.21,1.37l8.12,13.17c.86,1.4,1.32,3.01,1.32,4.64v.85h15.12v-.3c0-1.51.39-3.02,1.14-4.33.59-1.06.9-2.25.9-3.45v-19.86c-.03-.97-.72-1.78-1.61-1.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.67,39.25s8.04-29.82-6.8-30.88c-12.18-1.46-23.92,7.35-35.38-.2C1.49,17.31.41,28.35,3.49,34.42c1.4,2.32,4.62,3.55,8.68,4.16l-1.06-1.72c-.51-.82-.65-1.83-.41-2.76.25-.95.87-1.73,1.73-2.2,1.66-.9,3.76-.3,4.79,1.38l.83,1.35v-13.29c0-1.87,1.4-3.47,3.19-3.64.73-.07,1.47.09,2.09.45v-1.06c0-.99.42-1.95,1.16-2.62.73-.67,1.73-1,2.73-.9,1.79.17,3.19,1.77,3.19,3.64v.95c.63-.36,1.36-.52,2.09-.45,1.79.17,3.19,1.77,3.19,3.64v2.1c.63-.36,1.37-.52,2.09-.45,1.79.17,3.19,1.77,3.19,3.64v11.52c3.16-.04,5.29.21,5.68,1.09h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMycierczneIcon);
export default __webpack_public_path__ + "static/media/Mycie ręczne_icon.400c0bcf07d1843f89c17c15932bf650.svg";
export { ForwardRef as ReactComponent };